import * as React from 'react'

// Simple table/grid icon for the table dropdown trigger
export const TableIcon = React.memo(({ className, ...props }) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_table)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.80754 0.950256C0.979527 0.95049 0.307887 1.62227 0.307541 2.45026V3.95026C0.307577 4.03552 0.317273 4.11936 0.330978 4.20074C0.317688 4.31524 0.307565 4.43133 0.307541 4.54938V21.0494C0.307541 22.7062 1.65077 24.0493 3.30754 24.0494H21.3075C22.861 24.0494 24.138 22.8685 24.2914 21.3555L24.3075 21.0494V4.54938C24.3075 4.27795 24.2682 4.01577 24.2006 3.76569V2.45026C24.2003 1.62219 23.5287 0.950362 22.7006 0.950256H1.80754ZM21.3075 21.0494H16.8075V10.5494H21.3075V21.0494ZM15.3075 21.0494H9.30754V10.5494H15.3075V21.0494ZM7.80754 21.0494H3.30754V10.5494H7.80754V21.0494ZM21.3075 5.45026V9.04938H16.8075V5.45026H21.3075ZM15.3075 5.45026V9.04938H9.30754V5.45026H15.3075ZM7.80754 5.45026V9.04938H3.30754V5.45026H7.80754Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_table'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
})

TableIcon.displayName = 'TableIcon'
